export default {
  apiURL: 'https://api.decathlon-easysample.com/'
}



// WEBPACK FOOTER //
// ./src/fetch/config.js